/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {
    REQUEST_MASTER_MENU,
    REQUEST_MASTER_MENU_FAILURE,
    REQUEST_MASTER_MENU_SUCCESS
} from "../../constant/UserAccessMenuConstant";

const initialState = {
    masterMenu: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const masterMenuReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_MASTER_MENU:
            return {
                ...state,
                masterMenu: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_MASTER_MENU_SUCCESS:
            return {
                ...state,
                masterMenu: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_MASTER_MENU_FAILURE:
            return {
                ...state,
                masterMenu: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
